import {startTransition, useEffect, useRef} from "react";
import {useHistory, useLocation} from "react-router-dom";

import {useRoutedModalState} from "./use_routed_modal_state";

interface IParams {
    routeParam: string;
    value?: string;
    idOpenStoreState: boolean;
    disableOpenAction?: boolean;
    removeRouteParamFromUrlOnFirstMount?: boolean;
    setModalState: (state: boolean) => void;
}

export const useRoutedModalStateSync = (params: IParams) => {
    const location = useLocation();
    const history = useHistory();
    const routedModal = useRoutedModalState(params.routeParam, params.value);
    /**
     * `paramsModalState` starts at false rather than at the current store state on purpose: a modal
     * that is created on first open is mounted *already open*, and seeding it with `true` would make
     * the first effect see "no change" and never push the history entry - the back button would then
     * not close the modal.
     *
     * Caveat: this makes the mount effect an action, so it is not idempotent - under StrictMode's
     * effect replay the second run would see the not-yet-committed router state and dispatch a
     * spurious close. The app does not enable StrictMode; revisit this seeding if that changes.
     */
    const prev = useRef({
        paramsModalState: false,
        routedModalState: routedModal.modalState
    });

    const setPrev = (state: boolean) => {
        prev.current = {
            paramsModalState: state,
            routedModalState: state
        };
    };

    useEffect(() => {
        // TODO: temporary solution, in the future it will be necessary to create URL based modal navigation
        if (useRoutedModalStateSync.hasBeenMounted) {
            return;
        }

        const searchParams = new URLSearchParams(location.search);

        if (params.routeParam && params.removeRouteParamFromUrlOnFirstMount && searchParams.has(params.routeParam)) {
            searchParams.delete(params.routeParam);
            history.replace({search: searchParams.toString()});
        }

        useRoutedModalStateSync.hasBeenMounted = true;
    }, []);

    useEffect(() => {
        if (params.idOpenStoreState !== prev.current.paramsModalState) {
            if (params.idOpenStoreState && params.disableOpenAction) {
                return;
            }

            /**
             * The history change re-renders the whole route below it. Marking it as a transition lets
             * React interrupt that render instead of blocking the frame that responds to the click -
             * it was the dominant INP processing cost on the offer listing (RP-793). The modal itself
             * does not wait for it: its visibility comes from the store, not from the route.
             */
            if (params.idOpenStoreState) {
                startTransition(() => routedModal.openModal());
                setPrev(true);
            } else {
                /**
                 * Be cautious with the modal closing mechanism;
                 * note that by default the modal is closed via history.goBack().
                 * This can cause issues if some other mechanism interferes with the history
                 * and, for example, calls history.push() with a cloned current state.
                 */
                startTransition(() => routedModal.closeModal(true));
                setPrev(false);
            }
        } else if (routedModal.modalState !== prev.current.routedModalState) {
            if (routedModal.modalState && params.disableOpenAction) {
                return;
            }

            params.setModalState(routedModal.modalState);
            setPrev(routedModal.modalState);
        }
    }, [routedModal.modalState, params.idOpenStoreState]);

    return {
        ...routedModal,
        isOpen: params.disableOpenAction ? false : routedModal.modalState,
        modalState: undefined
    };
};

useRoutedModalStateSync.hasBeenMounted = false;
import {startTransition, useEffect, useRef} from "react";
import {useHistory, useLocation} from "react-router-dom";

import {useRoutedModalState} from "./use_routed_modal_state";

interface IParams {
    routeParam: string;
    value?: string;
    idOpenStoreState: boolean;
    disableOpenAction?: boolean;
    removeRouteParamFromUrlOnFirstMount?: boolean;
    setModalState: (state: boolean) => void;
}

export const useRoutedModalStateSync = (params: IParams) => {
    const location = useLocation();
    const history = useHistory();
    const routedModal = useRoutedModalState(params.routeParam, params.value);
    /**
     * `paramsModalState` starts at false rather than at the current store state on purpose: a modal
     * that is created on first open is mounted *already open*, and seeding it with `true` would make
     * the first effect see "no change" and never push the history entry - the back button would then
     * not close the modal.
     *
     * Caveat: this makes the mount effect an action, so it is not idempotent - under StrictMode's
     * effect replay the second run would see the not-yet-committed router state and dispatch a
     * spurious close. The app does not enable StrictMode; revisit this seeding if that changes.
     */
    const prev = useRef({
        paramsModalState: false,
        routedModalState: routedModal.modalState
    });

    const setPrev = (state: boolean) => {
        prev.current = {
            paramsModalState: state,
            routedModalState: state
        };
    };

    useEffect(() => {
        // TODO: temporary solution, in the future it will be necessary to create URL based modal navigation
        if (useRoutedModalStateSync.hasBeenMounted) {
            return;
        }

        const searchParams = new URLSearchParams(location.search);

        if (params.routeParam && params.removeRouteParamFromUrlOnFirstMount && searchParams.has(params.routeParam)) {
            searchParams.delete(params.routeParam);
            history.replace({search: searchParams.toString()});
        }

        useRoutedModalStateSync.hasBeenMounted = true;
    }, []);

    useEffect(() => {
        if (params.idOpenStoreState !== prev.current.paramsModalState) {
            if (params.idOpenStoreState && params.disableOpenAction) {
                return;
            }

            /**
             * The history change re-renders the whole route below it. Marking it as a transition lets
             * React interrupt that render instead of blocking the frame that responds to the click -
             * it was the dominant INP processing cost on the offer listing (RP-793). The modal itself
             * does not wait for it: its visibility comes from the store, not from the route.
             */
            if (params.idOpenStoreState) {
                startTransition(() => routedModal.openModal());
                setPrev(true);
            } else {
                /**
                 * Be cautious with the modal closing mechanism;
                 * note that by default the modal is closed via history.goBack().
                 * This can cause issues if some other mechanism interferes with the history
                 * and, for example, calls history.push() with a cloned current state.
                 */
                startTransition(() => routedModal.closeModal(true));
                setPrev(false);
            }
        } else if (routedModal.modalState !== prev.current.routedModalState) {
            if (routedModal.modalState && params.disableOpenAction) {
                return;
            }

            params.setModalState(routedModal.modalState);
            setPrev(routedModal.modalState);
        }
    }, [routedModal.modalState, params.idOpenStoreState]);

    return {
        ...routedModal,
        isOpen: params.disableOpenAction ? false : routedModal.modalState,
        modalState: undefined
    };
};

useRoutedModalStateSync.hasBeenMounted = false;
